import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';

@Component({
  selector: 'app-participant-correspondence',
  imports: [TableComponent, ColumnComponent],
  template: ` <app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [stripedRows]="false"
    theme="Dark"
    recordLabel="Correspondence"
    [globalFilterFields]="[
      'type',
      'subType',
      'primaryValue',
      'secondaryValue',
      'isPrimary',
      'comment',
    ]"
  >
    <app-column name="type" label="Type" width="20%" />
    <app-column name="subType" label="SubType" width="20%" />
    <app-column name="primaryValue" label="Primary Value" width="20%" />
    <app-column name="secondaryValue" label="Secondary Value" width="20%" />
    <app-column name="isPrimary" label="Is Primary" width="20%" format="b" />
    <app-column
      name="comment"
      label="Comment"
      [fullRow]="true"
      [fullRowLabel]="true"
    >
      <ng-template #item let-row>
        <span class="tw-text-wrap tw-leading-6">{{ row.comment }}</span>
      </ng-template>
    </app-column>
  </app-table>`,
  styles: [],
})
export class ParticipantCorrespondenceComponent {
  @Input() dataSource: any;
}
